import { Anchoring } from './Anchoring';
export default class AnchoringAweighData extends Anchoring {
    constructor(anchor, freeText) {
        super(anchor, freeText);
    }
}
//# sourceMappingURL=AnchoringAweighData.js.map